import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../core/authentication/auth.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html'
})
export class IndexComponent implements OnInit {

  name: string;
  isAuthenticated: boolean;
  subscription:Subscription;

   constructor(private authService:AuthService) { 

  }

  ngOnInit() {
    this.subscription = this.authService.authNavStatus$.subscribe(status => this.isAuthenticated = status);
     //console.log(this.isAuthenticated)
    this.name = this.authService.name();
  } 

   async signout() {
    await this.authService.signout();     
  }

  
}
